import Wizard from 'scoreboard/components/wizard'
import _ from 'lodash'
import FilterStep1 from './filter-step1'
import DatasetsRollupFilterStep2 from './datasets-rollup-filter-step2'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import DatasetsDateFilterStep2 from './datasets-date-filter-step2'
import DatasetsDateInPeriodFilterStep2 from './datasets-date-in-period-filter-step2'
import DatasetsYesNoFilterStep2 from './datasets-yes-no-filter-step2'
import DatasetsRollupIsFilterStep2 from './datasets-rollup-is-filter-step2'
import DatasetsTimeFilterStep2 from './datasets-time-filter-step2'
import DatasetsDateTimeFilterStep2 from './datasets-date-time-filter-step2'
import isGeographicOrRollup from '../is-geographic-or-rollup'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO, DATE, CALENDAR_PERIOD, TIME, DATE_TIME } = DataType

var FilterWizard = Wizard.extend({

	/**
	 * Wizard used to create and edit dataset filters
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model is a Dataset
	 *
	 * @param {Array} options.filter is the filter we're working with
	 *
	 * @param {Boolean} options.new indicates if this is a new filter or not
	 *
	 * @param {Boolean} options.showPermissionFilters whether we should show
	 * permission filters
	 *
	 * @param {String} [options.allowAppCalendar] whether "Current Calendar"
	 * should be an option when working with date filters
	 *
	 * @param {Boolean} [options.rollupPermissions=false] whether rollup
	 * permissions should be displayed instead of the usual cascade checkboxes
	 * (#20557)
	 *
	 * @param {Dataset[]} options.datasetsById
	 */
	initialize: function(options) {
		this.options = options || {}
		var xhr = $.get('api/datasets/' + options.model.id + '/field-suggestions')
		Wizard.prototype.initialize.call(this, _.defaults({}, options, {
			xhr: xhr,
			// we start off assuming just one step for a new filter
			steps: 1
		}))
	},

	_viewConstructor: function(step) {
		if (step == 1) {
			return FilterStep1
		}
		var fieldId = this.options.filter.fieldId
		const field = this.options.model.combinedFieldsById[fieldId]
		const underlyingField = this.options.model.getUnderlyingField(field)
		var dataType = underlyingField.dataType
		if (dataType === DATE || dataType === CALENDAR_PERIOD) {
			return this.options.filter.operator === 'in-period'
				? DatasetsDateInPeriodFilterStep2 : DatasetsDateFilterStep2
		}
		if (dataType === DATE_TIME) {
			return DatasetsDateTimeFilterStep2
		}
		if (dataType === TIME) {
			return DatasetsTimeFilterStep2
		}
		if (dataType === YES_NO) {
			return DatasetsYesNoFilterStep2
		}
		if (isGeographicOrRollup(dataType)) {
			if (this.options.filter.operator === 'is') {
				return DatasetsRollupIsFilterStep2
			} else {
				return DatasetsRollupFilterStep2
			}
		}
		throw new Error('Haven\'t implemented filters for ' + dataType + ' fields')
	},

	/**
	 * Returns the correct title for step 2 of the wizard
	 */
	step2Title: function() {
		var field = this.options.model.combinedFieldsById[this.options.filter.fieldId]
		var addOrEdit = this.options.lockField ? 'edit' : 'add'
		return i18n.get('datasets.filters.' + addOrEdit, field && field.label)
	},

	finish: function(options) {
		_.extend(this.options, options)
		this.trigger('done', this.options.filter,
			_.get(options, 'treeItems'), this.options.model)
	}

})

export default FilterWizard

FilterWizard.__filename__ = 'datasets/filters/filter-wizard.js'
